import { useRef, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { FileText, Upload, X, Loader2, ExternalLink } from "lucide-react";

export function PdfUpload({ value, onChange, slug }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const send = async (file) => {
    if (!file) return;
    if (!slug) return toast.error("Preencha o slug do tutorial antes de enviar o PDF.");
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const r = await api.post(`/admin/upload-pdf/${slug}`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(r.data.url);
      toast.success("PDF enviado!");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Falha ao enviar PDF.");
    } finally { setBusy(false); if (ref.current) ref.current.value = ""; }
  };

  return (
    <div className="space-y-2" data-testid="field-pdf_url">
      <div className="flex flex-wrap items-center gap-2">
        <button type="button" disabled={busy} onClick={() => ref.current?.click()} data-testid="field-pdf_url-btn"
          className="inline-flex items-center gap-2 text-sm px-3 py-2 rounded-lg bg-amber-400/10 text-amber-300 border border-amber-400/30 hover:bg-amber-400/20 disabled:opacity-50">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />} {busy ? "Enviando..." : value ? "Substituir PDF" : "Enviar PDF"}
        </button>
        {value && (
          <>
            <a href={value} target="_blank" rel="noopener noreferrer" data-testid="field-pdf_url-open"
              className="inline-flex items-center gap-1.5 text-sm text-cyan-300 hover:underline"><FileText className="w-4 h-4" /> Ver PDF <ExternalLink className="w-3 h-3" /></a>
            <button type="button" onClick={() => onChange("")} data-testid="field-pdf_url-remove"
              className="inline-flex items-center gap-1 text-xs text-gray-400 hover:text-red-300"><X className="w-3.5 h-3.5" /> Remover</button>
          </>
        )}
        {!value && <span className="text-xs text-gray-400">Sem arquivo próprio — o site gera o PDF automaticamente a partir dos passos.</span>}
      </div>
      <input ref={ref} type="file" accept="application/pdf,.pdf" className="hidden" onChange={(e) => send(e.target.files?.[0])} data-testid="field-pdf_url-input" />
      <input value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder="ou cole a URL de um PDF já hospedado"
        className="w-full bg-[#0B0F17] border border-white/10 rounded-lg px-3 py-2 outline-none text-xs text-gray-400" data-testid="field-pdf_url-url" />
    </div>
  );
}
